import { IdType } from "./BaseTypes";
import { FileType } from "./File";

// ---------------------------
// Category Data
// ---------------------------
export type CategoryDataType = {
  filterId: IdType;
  value: string | number;
};

// ---------------------------
// Item Status
// ---------------------------
export const ITEM_STATUS = {
  ACTIVE: "active",
  DRAFT: "draft",
  RESERVED: "reserved",
  HIDDEN: "hidden",
  DELETED: "deleted",
} as const;

export type ItemStatusType = (typeof ITEM_STATUS)[keyof typeof ITEM_STATUS];
export const ITEM_STATUS_VALUES = Object.values(
  ITEM_STATUS,
) as ItemStatusType[];

// ---------------------------
// Item
// ---------------------------
export type ItemType = {
  _id: IdType;
  ownerId: IdType;
  title: string;
  description: string;
  price: number; // Ensure >= 0 in your logic
  category: IdType;
  categoryData: CategoryDataType[];
  imageUrls: FileType[];
  status: ItemStatusType;
  text: string;
  updatedAt: string; // ISO date string
  createdAt: string; // ISO date string
};

export type ItemPostType = Omit<
  ItemType,
  "_id" | "ownerId" | "createdAt" | "updatedAt"
>;

export type ItemPutType = Partial<ItemType> & {
  _id: IdType;
  categoryData?: Partial<CategoryDataType>[];
};
